import { VIDEO_RECORDING } from './constants';

export default class VideoUploader {
  constructor(recordingApi) {
    this.recordingApi = recordingApi;
  }

  async upload(shipmentId, blob, durationMs) {
    try {
      const { id, url } = await this.recordingApi.createVideo(shipmentId);

      await this._putWithRetry(url, blob);

      await this.recordingApi.confirmUpload(id, {
        duration_ms: durationMs,
        file_size: blob.size,
      });
    } catch (err) {
      console.error(
        `[VideoUploader] Upload failed for shipment ${shipmentId}:`,
        err,
      );
      throw err;
    }
  }

  async _putWithRetry(url, blob) {
    const { MAX_RETRY_ATTEMPTS, RETRY_BASE_DELAY_MS, UPLOAD_TIMEOUT_MS } =
      VIDEO_RECORDING;

    for (let attempt = 0; attempt < MAX_RETRY_ATTEMPTS; attempt++) {
      const controller = new AbortController();
      const timer = setTimeout(() => controller.abort(), UPLOAD_TIMEOUT_MS);
      try {
        const res = await fetch(url, {
          method: 'PUT',
          body: blob,
          headers: { 'Content-Type': blob.type },
          signal: controller.signal,
        });
        if (res.ok) return;
        throw new Error(`S3 PUT failed: ${res.status}`);
      } catch (err) {
        if (attempt === MAX_RETRY_ATTEMPTS - 1) throw err;
        await new Promise(r =>
          setTimeout(r, RETRY_BASE_DELAY_MS * (attempt + 1)),
        );
      } finally {
        clearTimeout(timer);
      }
    }
  }
}
